






































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import CounterItem from '@/components/counters/CounterItem.vue';
import { Counter } from '@/modules/backend/Entities/Counter';

@Component({
  components: {
    'counter-item': CounterItem
  }
})
export default class CounterInfoCard extends Vue {
  @Prop({ required: true }) private readonly counter!: Counter;

  private getDateDiffInDays(date: Date): number {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const daysLeft: number = Math.abs(Date.now() - Number(date)) / (1000 * 60 * 60 * 24);
    return Math.max(Math.ceil(daysLeft), 0);
  }
}
